/**
 * Cintra Product > Feature > Section
 */
export type CintraProduct = 'Bureau' | 'Payroll' | 'EmployeeHub' | 'AdminHub' | 'Unset';

export const getProductHelpUrl = (cintraProduct: CintraProduct) =>
  cintraProduct === 'Payroll' || cintraProduct === 'Bureau'
    ? 'https://pssg.zendesk.com/hc/en-gb'
    : 'https://employeehub.zendesk.com/hc/en-gb';
